/**
 * This is the maximum number of rates that can be created in a ticketing form.
 * It is used to limit the number of rates that can be created in a ticketing form.
 */
export const MAX_RATES_LIMIT = 200;
/**
 * This is the maximum number of rates that created in a ticketing form in our database since 2025/01/01.
 * Since 2025/04/23, we have a limit of 200 rates per ticketing form.
 */
export const MAX_RATES_BY_TICKETING_IN_DB_LIMIT = 400;
export const MAX_RATE_PHOTOS = 20;
